import styled from "styled-components";
import { Colors } from "../../utils/style/colors";
import UIToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export const Wrapper = styled.div`
  background: ${Colors.gray05};
  animation: fadeIn 0.5s;
  *:not(svg *) {
    user-select: none;
  }
`;

export const RightControls = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  ${(props) =>
    !props.isEnabled &&
    `
      pointer-events: none;
      opacity: .5;
    `};
`;

export const ToggleButtonGroup = styled(UIToggleButtonGroup)`
  box-shadow: none !important;
  border: 1px solid ${Colors.gray30};
`;

export const Form = styled.div`
  overflow: scroll;
  height: calc(100% - 50px);
  padding: 10px 20px;
  transition: 0.3s all;
  animation: 1s fadeIn;
  opacity: 1;
`;
